import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function detailBatchFileReducer(state = initialState.batchFile, action) {
    switch (action.type) {
        case types.LOAD_BATCH_FILE_DETAIL_SUCCESS:
            return action.batchFile;
        default:
            return state;
    }
}
